module.exports = __webpack_public_path__ + "videos/test.7a5a8ea.mp4";